<template>
    <BaseView contentClass="bg-white" :loader="false">
        <template v-slot:top>
            <TitleBar
                :title="$t('Device')"
                @left-click="close"
            >
                <template v-slot:leftIcon>
                    <CloseIcon />
                </template>
            </TitleBar>
        </template>

        <p v-if="usedQuota !== null" class="mb-4 pb-4 border-b border-50">{{ usedQuota }}% of space used</p>

        <p class="mb-4 pb-4 border-b border-50">Device is
            <span v-if="online">
                online
            </span>
            <span v-else>
                offline
            </span>
        </p>

        <div class="mb-4 pb-4 border-b border-50 flex">
            <div class="flex-1">
                Inspections not sent yet: {{ inspectionCount }}
            </div>
            <button
                class="btn btn-default btn-primary"
                type="button"
                :disabled="isOnFreePlan && reachedFreePlanLimit"
                @click="sendInspections"
            >
                <starred-item :starred="isOnFreePlan && reachedFreePlanLimit">
                    <span>{{ $t("Send now") }}</span>
                </starred-item>
            </button>
        </div>


        <div class="mb-4 pb-4 border-b border-50 flex">
            <div class="flex-1">
                 Push notifications: {{ pushPermission }}
            </div>
            <button
                v-if="notificationsAreSupported"
                class="btn btn-default btn-primary"
                type="button"
                @click="enablePush"
            >
                    {{ $t("Enable") }}
            </button>
        </div>


        <div class="mb-4 pb-4 border-b border-50 flex">
            <div class="w-1/3">
                 Version {{ version }}
            </div>
            <div class="w-2/3 text-right">
            <button
                class="btn btn-default btn-primary mb-2"
                type="button"
                @click="update"
            >
                    {{ $t("Check for updates") }}
            </button>
            <button
                class="btn btn-default btn-primary"
                type="button"
                @click="reload"
                >
                    {{ $t("Reload App") }}
            </button>
            </div>
        </div>

    </BaseView>
</template>

<script>
import { version } from '@mobile/../package.json';
import { mapGetters } from 'vuex';
import BaseView from '@mobile/components/BaseView.vue';
import CloseIcon from '@mobile/components/Icons/CloseIcon.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import TitleBar from '@/components/TitleBar.vue';
import globals from '@/util/globals';
import StarredItem from '../components/StarredItem';

export default {
    name: 'Device',

    mixins: [
        OnFreePlan,
    ],

    components: {
        StarredItem,
        BaseView,
        TitleBar,
        CloseIcon,
    },


    data: () => ({
        storage: {
            available: null,
            used: null,
        },
        pushPermission: window.Notification && window.Notification.permission === 'granted',
        notificationsAreSupported: window.Notification,
        canGoBack: false,
    }),

    computed: {
        ...mapGetters({
            inspectionCount: 'inspections/queue_count',
            online: 'connection/online',
        }),
        usedQuota() {
            if (this.storage.used !== null && this.storage.available !== null) {
                return Math.round(this.storage.used / this.storage.available * 100);
            }
            return null;
        },
        version() {
            return version;
        },
        reachedFreePlanLimit() {
            return this.user.subscription.inspections && this.user.subscription.inspections.limit_reached;
        },
    },

    created() {
        this.$store.dispatch('inspections/loadQueueFromDB');

        if ('webkitTemporaryStorage' in navigator) {
            navigator.webkitTemporaryStorage.queryUsageAndQuota(
                (usedBytes, grantedBytes) => {
                    this.storage.available = grantedBytes;
                    this.storage.used = usedBytes;
                },
            );
        }
    },

    // this makes sure we only go back on close if that is still inside the app
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.matched.length > 0) {
                vm.canGoBack = true;
            }
        });
    },

    methods: {
        update() {
            if (window.serviceWorkerRegistration) {
                console.log('trying to update service worker');
                window.serviceWorkerRegistration
                    .update()
                    .catch(() => {});
            }
        },

        reload() {
            this.$nextTick(() => globals.location.reload(true));
        },

        enablePush() {
            if (window.Notification.permission !== 'granted') {
                console.log('trying to get permissions');
                window.Notification.requestPermission().then((result) => {
                    this.pushPermission = window.Notification && window.Notification.permission === 'granted';
                });
            }
        },

        sendInspections() {
            this.$store.dispatch('inspections/sendQueue');
        },

        close() {
            if (this.canGoBack) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'todos' });
            }
        },
    },

};
</script>
